<button
  type="button"
  class="underlined-text-button"
  [attr.aria-label]="ariaLabel() || null"
  [disabled]="isDisabled()"
  (click)="buttonClicked.emit()"
>
  {{ label() }}
</button>
